module.exports = __webpack_public_path__ + "img/medellin.5f5c6332.defae12c.png";